import { api } from './api';

export interface GoogleCalendarStatus {
  connected: boolean;
  googleEmail: string | null;
  isActive: boolean;
}

export const googleCalendarApi = {
  /**
   * Get the current Google Calendar connection status
   */
  getStatus: async (): Promise<GoogleCalendarStatus> => {
    const response = await api.get('/integrations/google/status');
    return response.data.data;
  },

  /**
   * Get the Google OAuth URL from the backend
   * The frontend will then redirect the browser to this URL
   */
  getConnectUrl: async (): Promise<string> => {
    const response = await api.get('/integrations/google/connect');
    return response.data.data.url;
  },

  /**
   * Toggle sync active/inactive
   */
  toggle: async (): Promise<{ isActive: boolean }> => {
    const response = await api.patch('/integrations/google/toggle');
    return response.data.data;
  },

  /**
   * Disconnect Google Calendar
   */
  disconnect: async (): Promise<void> => {
    await api.delete('/integrations/google/disconnect');
  },

  /**
   * Get sync diagnostics for debugging
   */
  getDiagnostics: async (): Promise<GoogleCalendarDiagnostics> => {
    const response = await api.get('/integrations/google/diagnostics');
    return response.data.data;
  },
};

export interface GoogleCalendarDiagnosticCheck {
  check: string;
  ok: boolean;
  detail: string;
}

export interface GoogleCalendarDiagnostics {
  healthy: boolean;
  checks: GoogleCalendarDiagnosticCheck[];
}
